import React from "react";
import CustomModal from "../../../assets/components/ModalComonent";

export default function AlertContainer({ show, handleClose, content }) {
  return (
    <CustomModal
      open={show}
      closeHandler={handleClose}
      inputDialog={true}
      dialogContent={content}
    />
  );
}
